require('./creditCancelError.scss');
// @ vendor
const React = require('react');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardError = require('components/commons/wizardError/wizardError');

const CreditCancelError = () => {
    const title = formatText('creditCancelError-title');
    const goBackButton = {
        label: <FormattedText value="creditCancelError-goBackButton" format="uppercase" />,
        url: '/myprofile/loans-mortgages'
    };
    const errorSubMessage = <FormattedText value="creditCancelError-message" />

    return (
        <article className="credit-cancel-error row no-gutter">
            <div className="col-xs-offset-2 col-xs-8">
                <WizardError errorMessage={title} mainButton={goBackButton} errorSubMessage={errorSubMessage} />
            </div>
        </article>
    );
};

module.exports = CreditCancelError;
